<template>
  <div class="solution">
    <!--顶部轮播 -->
    <div class="swpier">
      <img :src="swiperImage" alt="">
    </div>
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="solution-list">
            <div class="solution-list-item" v-for="(item, index) in list" :key="index" @click="getDetails(item)">
              <!--  -->
              <div class="image-left solution-list-box" v-if="index % 2 == 0">
                <div class="item-image image product-image">
                  <img class="images" :src="item.image" alt="">
                </div>
                <div class="item-box">
                  <div class="item-title">
                    {{ item.title }}
                  </div>
                  <div class="item-title-line"></div>
                  <div class="item-tetx">
                    {{ item.description }}
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="image-right solution-list-box" v-if="index % 2 != 0">
                <div class="item-box">
                  <div class="item-title"> {{ item.title }}</div>
                  <div class="item-title-line"></div>
                  <div class="item-tetx">
                    {{ item.description }}
                  </div>
                </div>
                <div class="item-image image product-image">
                  <img class="images" :src="item.image" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBotom></footerBotom>
  </div>
</template>
<script>
import { solutionList, nav } from '@/request/api';
import footerBotom from '@/components/footer.vue'
export default {
  components: {
    footerBotom
  },
  data() {
    return {
      list: [],
      swiperImage: ""
    }
  },
  created() {
    this.getNav()
    this.getSolutionList()
  },
  methods: {
    getNav() {
      nav({}).then(res => {
        this.swiperImage = res.data[1].image
      })
    },
    getSolutionList() {
      solutionList({}).then(res => {
        if (res.code == 1) {
          this.list = res.data.list
        }
      })
    },
    getDetails(item) {
      this.$router.push({
        path: '/solutionDetails',
        query: {
          productId: item.id,
        }
      })
    },
  }
}
</script>
<style scoped lang="scss">
.swpier {
  margin-top: 90px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    // vertical-align: middle;
  }
}

.solution-list {
  .solution-list-item {
    margin-bottom: 60px;
    cursor: pointer;
    .solution-list-box {
      display: flex;
      align-items: stretch;

      .item-image {
        // flex: 1;
        cursor: pointer;
        max-width: 50%;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .item-box {
        flex: 1;
        // max-width: 50%;
        padding: 51px 79px;
        background: #F7F7F7;

        .item-title {
          font-size: 24px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #333333;
        }

        .item-title-line {
          margin-top: 17px;
          width: 46px;
          height: 1px;
          border-bottom: 2px solid #DB2733;
        }

        .item-tetx {
          margin-top: 16px;
          font-size: 16px;

          font-weight: 400;
          color: #666666;
          line-height: 26px
        }

      }
    }
  }
}

@media screen and (max-width:767px) {
  .solution-list {
    .solution-list-item {
      margin-bottom: 30px;

      .solution-list-box {
        display: block;
        // align-items: stretch;

        .item-image {
          width: 100% !important;
          max-width: 100% !important;

          img {
            width: 100%;

          }
        }

        .item-box {
          padding: 30px;
          background: #F7F7F7;

          .item-title {
            font-size: 24px;
            font-family: Arial-Bold, Arial;
            font-weight: bold;
            color: #333333;
          }

          .item-title-line {
            margin-top: 17px;
            width: 46px;
            height: 1px;
            border-bottom: 2px solid #DB2733;
          }

          .item-tetx {
            margin-top: 16px;
            font-size: 16px;

            font-weight: 400;
            color: #666666;
            line-height: 26px
          }

        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solution/solution.vue